import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatMessageMeta } from '../../../../components/ChatMessageMeta';
import { CHATBOT_ID } from '../../../../constants/chatbotId';
import { currentOpenChatIDSelector } from '../../../../selectors';
import { EOutcomingStatus, TMessage, TOutcomingStatus } from '../../../../types/messages';
import { getStatusIcon } from '../../utils';

interface IChatMessageMetaContainerProps {
  message: TMessage & { status: TOutcomingStatus };
}

export const ChatMessageMetaContainer: React.FC<IChatMessageMetaContainerProps> = ({
  message: { status, created, isOutcoming, offers },
}) => {
  const chatId = useSelector(currentOpenChatIDSelector) || '';
  const isOfferMessage = offers && offers.length > 0;
  const isChatbotOfferMessage = chatId === CHATBOT_ID && isOfferMessage && !isOutcoming;

  const statusIcon = React.useMemo(
    () => (isOutcoming && status !== EOutcomingStatus.Failed ? getStatusIcon(status) : null),
    [isOutcoming, status],
  );

  if (isChatbotOfferMessage) {
    return null;
  }

  return <ChatMessageMeta created={created} statusIcon={statusIcon} />;
};
